import { pythonPublicClient } from "./python-http-client.service";
import {
  Attribution,
  CheckoutInput,
  CheckoutResponse,
  CommerceCatalog,
  CommerceQuote,
  PublicOrder,
} from "../models/commerce.model";

export const getCommerceCatalog = async () =>
  (await pythonPublicClient.get<CommerceCatalog>("/api/commerce/catalog")).data;

export const getCommerceQuote = async (
  productCode: string,
  durationMonths: number,
  couponCode = "",
) =>
  (
    await pythonPublicClient.post<CommerceQuote>("/api/commerce/quotes", {
      productCode,
      durationMonths,
      couponCode,
      addonQuantities: {},
    })
  ).data;

export const createCommerceCheckout = async (input: CheckoutInput) =>
  (
    await pythonPublicClient.post<CheckoutResponse>(
      "/api/commerce/checkouts",
      input,
    )
  ).data;

export const verifyCommercePayment = async (input: {
  orderId: string;
  statusToken: string;
  razorpayPaymentId: string;
  razorpayOrderId: string;
  razorpaySignature: string;
}) =>
  (
    await pythonPublicClient.post<PublicOrder>(
      "/api/commerce/payments/verify",
      input,
    )
  ).data;

export const getCommerceOrder = async (orderId: string, statusToken: string) =>
  (
    await pythonPublicClient.get<PublicOrder>(
      `/api/commerce/orders/${encodeURIComponent(orderId)}`,
      { headers: { "X-ShopKaBot-Order-Token": statusToken } },
    )
  ).data;

export const trackCommerceEvent = (
  event: string,
  attribution: Attribution,
  extra: { productCode?: string; durationMonths?: number } = {},
) =>
  pythonPublicClient
    .post("/api/commerce/events", {
      event,
      anonymousSessionId: attribution.anonymousSessionId,
      page: window.location.pathname,
      attribution,
      ...extra,
    })
    .catch(() => undefined);
